// src/lib/supabaseClient.ts
// Updated: 2026-08-02 17:49:00 CDT
// Purpose: Single Supabase client instance for the entire app.
// IMPORTANT: Do NOT create another client anywhere else—always import from here.

import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url =
  import.meta.env.VITE_SUPABASE_URL ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
const anonKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ||
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.error(
    "[supabaseClient] Missing VITE_SUPABASE_URL or a Supabase publishable/anon key. " +
      "Set these in your env (Cloudflare Pages for prod; .env.local for local dev)."
  );
}

export const SUPABASE_URL = url ?? '';
export const SUPABASE_PUBLISHABLE_KEY = anonKey ?? '';
export const supabase: SupabaseClient = createClient(url ?? "", anonKey ?? "", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    debug: true,
    // Unique key so this app never clashes with any other Supabase app on this origin.
    storageKey: "sb-admin-console-auth",
  },
  global: {
    fetch: (input, init) => globalThis.fetch(input, init),
    headers: { "X-Client-Info": "is-it-published-yet-admin/secure-guard" },
  },
});
